/**
 * Subcategory constants for requirement management.
 */

import type { SubcategoryType } from '@/types';
import type { Translate } from '@/i18n/translate';

export interface SubcategoryOption {
  key: SubcategoryType;
  label: string;
}

export const SUBCATEGORY_OPTIONS: SubcategoryOption[] = [
  { key: 'Mcu', label: 'MCU及中间件' },
  { key: 'Communication', label: '通讯' },
  { key: 'Sensor', label: '传感器' },
  { key: 'SocAndMiddleware', label: 'SoC及中间件' },
  { key: 'DiagAndFault', label: '诊断和故障' },
  { key: 'TimeSync', label: '时间同步' },
  { key: 'UpgradeAndPower', label: '升级和上下电' },
  { key: 'FunctionalSafety', label: '功能安全' },
  { key: 'CyberSecurity', label: '网络安全' },
  { key: 'Other', label: '其他' },
];

export const SUBCATEGORY_MAP: Record<SubcategoryType, string> = Object.fromEntries(
  SUBCATEGORY_OPTIONS.map(({ key, label }) => [key, label])
) as Record<SubcategoryType, string>;

/** Translated copy of SUBCATEGORY_OPTIONS; `key` stays untouched. */
export const getSubcategoryOptions = (t: Translate): SubcategoryOption[] =>
  SUBCATEGORY_OPTIONS.map(({ key, label }) => ({ key, label: t(label) }));

/** Fixed status options for requirement filtering. */
export const STATUS_FILTER_OPTIONS = [
  { value: 'created', label: 'created' },
  { value: 'updated', label: 'updated' },
  { value: 'released', label: 'released' },
  { value: 'delivered', label: 'delivered' },
  { value: 'reject', label: 'reject' },
];
